// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","textAreaWrapper":"textArea_textAreaWrapper__h9Ghu","textAreaWrapper__disabled":"textArea_textAreaWrapper__disabled__1l6LC"};